"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAe10 = exports.ae10UseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ArticleBase_1 = require("../../ArticleBase");
const echain_product_models_1 = require("@igus/echain-product-models");
exports.ae10UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.ae,
    },
};
exports.isAe10 = echain_shared_modelling_1.UseableUtil.createGuard(exports.ae10UseableDef);
//# sourceMappingURL=Ae10.js.map